import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
export var getByRef = function getByRef(state) {
  return function (ref) {
    return state.items.find(function (item) {
      return item.ref === ref;
    });
  };
};
export var get = function get(state) {
  return state.items;
};